// @ts-nocheck
import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import initAppReducer, {getGlobalConfig} from './initAppSlice';
import Config from '../../Config';
import Affiliate from '../../utilities/affiliate';
import CustomerTracking from '../../utilities/customerTracking';

export default class AppInitInitializableModule implements IInitializableModule {
  protected name: string = 'InitApp module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {}

  public async StartModule(context: IEpiserverContext): Promise<void> {
    if (typeof window !== 'undefined' && window.location?.pathname === '/kmsi') {
      return;
    }
    //check dealer exists
    Affiliate.setAffiliate();

    CustomerTracking.setTracking();

    this.setAppConfig(await context.dispatch(getGlobalConfig()));
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'initApp',
      reducer: initAppReducer,
    };
  }

  private setAppConfig(res: any): void {
    const config = res.payload || {};
    Config.energyCallCenter = config.energyCallCenter;
    Config.idfCellcomCenter = config.idfCellcomCenter;
    Config.defaultLoginTemplate = config.defaultLoginTemplate;
    Config.logoutPage = config.logoutPage ? new URL(config.logoutPage).pathname.substring(1) : '/redirect-pages/logout/';
    Config.errorPageNotFound = config.notFoundPage ? new URL(config.notFoundPage).pathname.substring(1) : '/404/';
    Config.iosTvApplicationUrl = config.appleStoreNavigation;
    Config.androidTvApplicationUrl = config.googlePlayNavigation;
    Config.businessLobbyUrl = config.businessLobby ? new URL(config.businessLobby).pathname.substring(1) : '/selfcarebusiness/business/';
    Config.cellcomServiceCenters = config.cellcomServiceCenters;
    Config.cgShowIdNumber = config.cgShowIdNumber;
    Config.numberCallCenterAbroad = config.numberCallCenterAbroad ? config.numberCallCenterAbroad : Config.numberCallCenterAbroad;
    Config.cooperationTermsLink = config.cooperationTermsLink;
    Config.cooperationPrivacyPolicyLink = config.cooperationPrivacyPolicyLink;
    Config.termsUrl = config.termsUrl;
    Config.imgMainBtnBubbleChatOpen = config.imgMainBtnBubbleChatOpen;
    Config.imgMainBtnBubbleChatClose = config.imgMainBtnBubbleChatClose;
    Config.defaultChatBubbleGroup = config.defaultChatBubbleGroup;
    Config.hideChatBox = config.hideChatBox;
    Config.abroadInsuranceLink = config.abroadInsuranceLink;
    Config.ecommerceLink = config.ecommerceLink;
    Config.cellcomShopLink = config.cellcomShopLink;
    Config.otpErrorPage = config.otpErrorPage;
    Config.advertisingInfoLink = config.advertisingInfoLink;
    Config.whatsAppSale = config.whatsAppSale;
    Config.whatsAppSelfCare = config.whatsAppSelfCare;
    Config.whatsAppTechnicalService = config.whatsAppTechnicalService;
    Config.thirdPartyDefaulText = config.thirdPartyDefaulText;
    Config.thirdPartyExtendedText = config.thirdPartyExtendedText;
    Config.thirdPartyBottomText = config.thirdPartyBottomText;
    Config.thirdPartyCloseTextButton = config.thirdPartyCloseTextButton;
    Config.thirdPartyExpandButtonText = config.thirdPartyExpandButtonText;
    Config.primaryEmailText = config.primaryEmailText;
    Config.primaryEmailMoreInfoUrl = config.primaryEmailMoreInfoUrl;
    Config.primaryEmailMoreInfoText = config.primaryEmailMoreInfoText;
    Config.organizationPortalUrlActivate = config.organizationPortalUrlActivate;
    Config.organizationPortalUrlUpgrade = config.organizationPortalUrlUpgrade;
    Config.receivingAdTitle = config.receivingAdTitle;
    Config.receivingAdText = config.receivingAdText;
    Config.moreInfoLinkText = config.moreInfoLinkText;
    Config.moreInfoLink = config.moreInfoLink;
    Config.newLoginUrl = config.newLoginUrl;
    Config.potentialCustomerDefaulText = config.potentialCustomerDefaulText;
    Config.potentialCustomerTooltipText = config.potentialCustomerTooltipText;
    Config.potentialCustomerBottomText = config.potentialCustomerBottomText;
    Config.potentialCustomerTextButton = config.potentialCustomerTextButton;
    Config.newFullLoginUrl = config.newFullLoginUrl;
    Config.useOldLogin = config.useOldLogin;
    Config.idfSaleUrl = config.idfSaleUrl;
    Config.idfHomePageUrl = config.idfHomePageUrl;
    Config.idfLoginUrl = config.idfLoginUrl;
    Config.abroadUrl = config.abroadUrl;
    Config.businessLandPageUrl = config.businessLandPageUrl;
    Config.internetSaleLink = config.internetSaleLink;
    Config.idfWhatsAppLink = config.idfWhatsAppLink;
    Config.protectedCookies = config.protectedCookies;
    Config.protectedCookiesPatterns = config.protectedCookiesPatterns;

    Config.selfCareInternetLink = config.selfCareInternetLink;
    Config.selfCareTvLink = config.selfCareTvLink;
    Config.selfCareCellularLink = config.selfCareCellularLink;
    Config.selfCareElectricityLink = config.selfCareElectricityLink;
    Config.selfCareAbroadLink = config.selfCareAbroadLink;

    Config.payDebtLink = config.payDebtLink;
    Config.updatePaymentMethodLink = config.updatePaymentMethodLink;
    Config.joinCellularServiceLink = config.joinCellularServiceLink;
    Config.loginPageLegalText = config.loginPageLegalText;
    Config.redirectToHboUrl = config.redirectToHboUrl;
    Config.redirectToDisneyUrl = config.redirectToDisneyUrl;
  }
}
